import { Component, inject, input, OnChanges, OnDestroy, SimpleChanges } from "@angular/core";
import { ChatPropertyComponent } from "../../components/chat-property/chat-property.component";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { ChatBoxComponent } from "@app/applications/chat/components/chat-box/chat-box.component";
import { ConversationsListComponent } from "@app/applications/chat/components/conversations-list/conversations-list.component";
import { ChatService } from "@app/shared/chat/services/chat.service";
import { ISwapRequestEntity } from "@app/shared/swap-request/interfaces/swap-request.interface";
import { IChatMessage } from "@app/shared/chat/interfaces/chat-message.interface";
import { Router } from "@angular/router";

@Component({
  selector: "app-chat-page",
  imports: [ChatPropertyComponent, CommonModule, TranslateModule, ChatBoxComponent, ConversationsListComponent],
  templateUrl: "./chat-page.component.html",
  styleUrl: "./chat-page.component.scss",
})
export class ChatPageComponent implements OnChanges, OnDestroy {
  chatService = inject(ChatService);
  router = inject(Router);

  conversationId = input<string>();
  swapRequest = input.required<ISwapRequestEntity>();
  resolvedMessages = input<IChatMessage[]>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes["swapRequest"]) {
      if (changes["swapRequest"].currentValue && !changes["swapRequest"].currentValue.isUnlocked) {
        this.router.navigate(["/swap-request-details", changes["swapRequest"].currentValue.id], {
          queryParams: { target: "chat" },
        });
      }
      this.chatService.setActiveSwapRequest(this.swapRequest());
    }
  }

  ngOnDestroy() {
    this.chatService.setActiveSwapRequest(undefined);
  }

  // TODO: check this
  isPropertyPanelVisible = false;
  togglePropertyPanel(visible: boolean) {
    this.isPropertyPanelVisible = visible;
  }
}
